import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = [{
  title: 'Información que Recopilamos',
  text: 'Recopilamos información personal que nos proporcionas voluntariamente al realizar una compra, como tu nombre y dirección de correo electrónico. No recopilamos información sensible ni datos financieros directamente — los pagos son procesados por plataformas de pago seguras de terceros.'
}, {
  title: 'Uso de la Información',
  text: 'Utilizamos tu información únicamente para procesar tu compra, darte acceso al producto digital adquirido y enviarte comunicaciones relacionadas con tu compra. No vendemos, alquilamos ni compartimos tu información personal con terceros con fines de marketing.'
}, {
  title: 'Protección de Datos',
  text: 'Implementamos medidas de seguridad razonables para proteger tu información personal. Sin embargo, ningún método de transmisión por Internet es 100% seguro y no podemos garantizar la seguridad absoluta de tus datos.'
}, {
  title: 'Cookies',
  text: 'Este sitio puede utilizar cookies para mejorar tu experiencia de navegación y analizar el tráfico del sitio. Puedes configurar tu navegador para rechazar cookies, aunque esto podría afectar la funcionalidad del sitio.'
}, {
  title: 'Cambios a esta Política',
  text: 'Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Los cambios serán publicados en esta página con la fecha de la última actualización.'
}];
const termsContent = [{
  title: 'Aceptación de los Términos',
  text: 'Al acceder y utilizar este sitio web y adquirir nuestros productos digitales, aceptas estar sujeto a estos términos y condiciones. Si no estás de acuerdo con alguno de estos términos, te pedimos que no utilices este sitio.'
}, {
  title: 'Producto Digital',
  text: 'IA Exprés 2026 es un producto digital informativo y educativo. Los resultados pueden variar según la dedicación, esfuerzo y circunstancias individuales de cada persona. No garantizamos resultados financieros específicos.'
}, {
  title: 'Acceso y Entrega',
  text: 'Una vez completada la compra, recibirás acceso inmediato al contenido digital. El acceso es personal e intransferible. Queda prohibida la reproducción, distribución o reventa del contenido sin autorización expresa.'
}, {
  title: 'Política de Reembolso',
  text: 'Debido a la naturaleza digital del producto y al acceso inmediato proporcionado, todas las ventas son finales. No se ofrecen reembolsos una vez que se ha entregado el acceso al contenido.'
}, {
  title: 'Limitación de Responsabilidad',
  text: 'Este producto se ofrece con fines informativos y educativos. No somos responsables por decisiones tomadas basándose en el contenido del producto ni por pérdidas o daños derivados del uso de la información proporcionada.'
}, {
  title: 'Propiedad Intelectual',
  text: 'Todo el contenido de IA Exprés 2026, incluyendo textos, gráficos, logos y materiales digitales, está protegido por derechos de autor. Queda prohibida su copia, modificación o distribución sin consentimiento previo por escrito.'
}];
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#0A121E] text-gray-500 py-8 text-center border-t border-white/5" data-id="element-48">
        <div className="max-w-6xl mx-auto px-4" data-id="element-49">
          <div className="flex items-center justify-center gap-4 mb-4 text-sm" data-id="element-50">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-gold transition-colors cursor-pointer" data-id="element-51">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-52">•</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-gold transition-colors cursor-pointer" data-id="element-53">
              Términos y Condiciones
            </button>
          </div>
          <p className="font-medium text-gray-400 mb-2" data-id="element-54">
            IA Exprés 2026 • Todos los derechos reservados
          </p>
          <p className="text-sm text-gray-600 max-w-2xl mx-auto" data-id="element-55">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-56">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-57">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} className="bg-[#0F1B2D] border border-gold/20 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-58">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-59">
                <h3 className="text-xl font-bold text-white" data-id="element-60">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10 cursor-pointer" data-id="element-61">
                  <XIcon className="w-5 h-5" data-id="element-62" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] space-y-6" data-id="element-63">
                <p className="text-sm text-gray-500" data-id="element-64">
                  Última actualización: Marzo 2026
                </p>
                {(activeModal === 'privacy' ? privacyContent : termsContent).map((section, index) => <div key={index} data-id="element-65">
                    <h4 className="text-gold font-semibold text-lg mb-2" data-id="element-66">
                      {section.title}
                    </h4>
                    <p className="text-gray-300 leading-relaxed text-[15px]" data-id="element-67">
                      {section.text}
                    </p>
                  </div>)}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}